import { BlockT, ClampPoint, ModelBase, ModelUtils, Point, TnEngineExtraContext, ViewEditor } from "pytha";
import { DeviceComponentT } from "./DeviceComponentT";
import { DeviceComponentClamp } from "../clamp-points/DeviceComponentClamp";


/**
 * 串口服务器
 */
export class DvrT extends DeviceComponentT {

    componentType: string = 'dvr';
    editor: ViewEditor;
    type: string = 'DvrT';
    connected: boolean = false;
    readonly positionUpdateCallBack: boolean = true;

    constructor(position = new Point(), entities: ModelBase[] = [], name = '', normal = null, axisX = null, uuid = null) {
        super('dvr', position, entities, name, normal, axisX, uuid);
        if (TnEngineExtraContext.getInstance().getCurrentViewEditor()) {
            this.editor = TnEngineExtraContext.getInstance().getCurrentViewEditor();
        }
    }

    attachClampPoints(editor: ViewEditor): ClampPoint[] {
        if (!!this._isLock) return [];
        let u2wChangedMatric4 = this.context.ucsContext.u2wChangedMatric4(this.axisX.clone(), this.normal.clone().cross(this.axisX), this.normal.clone(), this.position.clone());
        this.u2wMatrix = u2wChangedMatric4
        let res = []
        let clamp = new DeviceComponentClamp(editor, this, this.position, 'position');
        res.push(clamp)

        this.clampPoints = res;
        return res;
    }

    copy(block: BlockT): this;
    copy(component: DeviceComponentT): this;
    copy(patrolPoint: DvrT): this;
    copy(block: any): this {
        super.copy(block); // 调用父类的 copy 方法
        if (block instanceof DvrT) {
            this.componentType = block.componentType; // 复制 DeviceComponentT 的特有属性
            this.group = block?.group;
        }
        this.componentType = 'dvr';
        return this;
    }

    clone(rename: boolean = false): this {
        const component = new DvrT().copy(this) as this; // 创建新实例并复制属性
        component.uuid = ModelUtils.generateUUID(); // 生成新的 UUID
        if (rename) {
            component.name = `${component.name}-${ModelUtils.generateUUID().substring(0, 6)}`;


        }
        return component;
    }

    toJson(rename: boolean = false) {
        const json = super.toJson();
        return {
            ...json,
            connected: this.connected,
        };
    }

    fromJson(json) {
        super.fromJson(json);
        this.connected = json?.connected;
        return this;
    }

}